export const STEPS = [
  { id: "landing", label: "Home" },
  { id: "upload", label: "Upload" },
  { id: "schema", label: "Schema" },
  { id: "map", label: "Map" },
  { id: "publish", label: "Publish" },
];
